/* Keep colour siblings apart without rebuilding their product cards. */
(() => {
  function spaceFamilies(items, familyOf, previous = '') {
    const groups = new Map();
    items.forEach((item, index) => {
      const family = familyOf(item);
      if (!groups.has(family)) groups.set(family, []);
      groups.get(family).push({ item, index });
    });
    const result = [];
    while (result.length < items.length) {
      const candidates = [...groups.entries()].filter(([, queue]) => queue.length);
      candidates.sort((a, b) => a[1][0].index - b[1][0].index);
      const remaining = items.length - result.length - 1;
      // Leave enough separators for every remaining family, including a dense tail.
      let choice = candidates.find(([family]) => family !== previous && candidates.every(([key, queue]) => {
        const count = queue.length - Number(key === family);
        return count <= (key === family ? Math.floor(remaining / 2) : Math.ceil(remaining / 2));
      }));
      if (!choice) {
        // A collection containing mostly one item cannot avoid every repeat.
        // Use the most frequent available alternative to minimize those repeats.
        const alternatives = candidates.filter(([family]) => family !== previous);
        choice = (alternatives.length ? alternatives : candidates)
          .sort((a, b) => b[1].length - a[1].length || a[1][0].index - b[1][0].index)[0];
      }
      previous = choice[0];
      result.push(choice[1].shift().item);
    }
    return result;
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { spaceFamilies };
  if (typeof document === 'undefined') return;
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const familyOf = (item) => {
    const heading = item.querySelector('.card__heading a, h3 a');
    const title = normalize(heading?.textContent);
    const fit = normalize(item.querySelector('.hcx-card-feature-line')?.textContent);
    return title ? `${title}|${fit}` : heading?.getAttribute('href') || item.id;
  };

  function arrangeNewestHomepageGrids(root = document) {
    const selector = '.hcx-featured-drop[data-hcx-space-newest-colourways="true"]';
    const sections = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) sections.unshift(root);
    sections.forEach((section) => {
      const grid = section.querySelector(':scope > ul.hcx-featured-drop__grid');
      if (!grid || grid.dataset.hcxNewestScattered === 'true') return;
      const items = [...grid.children].filter((item) => item.matches('li') &&
        !item.hidden && getComputedStyle(item).display !== 'none' && item.querySelector('.card__heading a, h3 a'));
      if (!items.length) return;
      const ordered = spaceFamilies(items, familyOf);
      if (!ordered.every((item, index) => item === items[index])) {
        // Keep each existing product card and every non-card slot intact.
        const slots = items.map((item) => {
          const slot = document.createComment('homepage-card');
          grid.insertBefore(slot, item);
          return slot;
        });
        ordered.forEach((item, index) => slots[index].replaceWith(item));
      }
      grid.dataset.hcxNewestScattered = 'true';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => arrangeNewestHomepageGrids(), { once: true });
  } else {
    arrangeNewestHomepageGrids();
  }
  document.addEventListener('shopify:section:load', (event) => arrangeNewestHomepageGrids(event.target));

  const container = document.getElementById('ProductGridContainer');
  if (!container || container.dataset.hcxFamilySpacingBound === 'true') return;
  container.dataset.hcxFamilySpacingBound = 'true';

  let frame = 0;
  const observer = new MutationObserver((records) => {
    if (records.some((record) => record.target.id === 'product-grid' ||
      [...record.addedNodes, ...record.removedNodes].some((node) => node.nodeType === 1 &&
        (node.id === 'product-grid' || node.querySelector?.('#product-grid'))))) schedule();
  });
  function arrange() {
    frame = 0;
    const grid = container.querySelector('#product-grid');
    if (!grid || grid.dataset.hcxSpaceColourways !== 'true') return;
    const items = [...grid.children].filter((item) => item.matches('.grid__item') &&
      !item.hidden && getComputedStyle(item).display !== 'none' && item.querySelector('.card__heading a, h3 a'));
    const ordered = spaceFamilies(items, familyOf);
    if (ordered.every((item, index) => item === items[index])) return;
    observer.disconnect();
    // Move complete nodes into the existing card slots; hidden anchors stay put.
    const slots = items.map((item) => {
      const slot = document.createComment('collection-card');
      grid.insertBefore(slot, item);
      return slot;
    });
    ordered.forEach((item, index) => slots[index].replaceWith(item));
    observer.observe(container, { childList: true, subtree: true });
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(arrange);
  }
  observer.observe(container, { childList: true, subtree: true });
  document.addEventListener('hcx:collection:products-appended', schedule);
  schedule();
})();
